import { ActionType, getType } from 'typesafe-actions';

import type { FixturesState, FixturesNotchesHolesState } from './fixtures.types';
import { fixturesActions } from './fixtures.actions';

const INITIAL_STATE_FIXTURES: FixturesState = [];
const INITIAL_STATE_FIXTURES_NOTCHES_HOLES: FixturesNotchesHolesState = [];

export function fixtures(
  state: FixturesState = INITIAL_STATE_FIXTURES,
  action: ActionType<typeof fixturesActions>
): FixturesState {
  switch (action.type) {
    case getType(fixturesActions.getFixtures.success):
      return action.payload;
  }

  return state;
}

export function fixturesNotchesHoles(
  state: FixturesNotchesHolesState = INITIAL_STATE_FIXTURES_NOTCHES_HOLES,
  action: ActionType<typeof fixturesActions>
): FixturesNotchesHolesState {
  switch (action.type) {
    case getType(fixturesActions.getFixturesNotchesHoles.success):
      return action.payload;
  }

  return state;
}
